import { Injectable } from '@angular/core';
import {
    AccountMappingData,
    AccountMappingEngine,
    AccountMappingTemplateStatus,
    EngineModes,
} from '@modeso/aumico-lib-templates-fe';
import {
    IAccount,
    IAccountMappingTemplate,
    IBalanceSwitchAccount,
    IFinStatements,
    IFinancialStatementInterpretation,
} from '@modeso/types__aumico-lib-annualreport-be';
import { cloneDeep } from 'lodash-es';
import { AccountsHelper } from '../helpers/accounts.helper';

@Injectable({ providedIn: 'root' })
export class FinancialStatementMapper {
    constructor() { }

    public mapFinStatement(finStatement: IFinStatements): AccountMappingData {
        const template = finStatement.templateAndAccountsMapping.template;
        const accounts = cloneDeep<IAccount[]>(finStatement.templateAndAccountsMapping.accounts);
        const roundedTemplateAccounts = AccountsHelper.roundAccountsValues(accounts);
        const balanceSwitchAccounts =
            finStatement.templateAndAccountsMapping.balanceSwitchAccounts != null
                ? cloneDeep<IBalanceSwitchAccount[]>(finStatement.templateAndAccountsMapping.balanceSwitchAccounts)
                : [];
        const roundedBalanceSwitchAccounts = AccountsHelper.roundAccountsValues(
            balanceSwitchAccounts,
        ) as IBalanceSwitchAccount[];
        const mapped: AccountMappingData = {
            template,
            status: AccountMappingTemplateStatus.MAPPED,
            accounts: roundedTemplateAccounts,
            balanceSwitchAccounts: roundedBalanceSwitchAccounts,
        };
        return mapped;
    }

    public getWorkingEngineFromData(
        data: AccountMappingData,
        sheetSystem: IFinancialStatementInterpretation,
        dates: { startDate: string; endDate: string },
        language: string,
        defaultLanguage: string,
        isPreviousDataTakenFromPreviousAnnualReport?: boolean,
        previousYearTemplate?: IAccountMappingTemplate,
    ): AccountMappingEngine | null {

        if (data.status === AccountMappingTemplateStatus.NEW) {
            return AccountMappingEngine.getMappingEngine(
                data.accounts,
                data.template,
                data.balanceSwitchAccounts != null ? data.balanceSwitchAccounts : [],
                sheetSystem,
                dates,
                EngineModes.MANUAL,
                language,
                undefined,
                undefined,
                previousYearTemplate
            );
        } else if (data.status === AccountMappingTemplateStatus.MAPPED) {
            return new AccountMappingEngine(
                data.accounts,
                data.template,
                data.balanceSwitchAccounts != null ? data.balanceSwitchAccounts : [],
                sheetSystem,
                dates,
                EngineModes.MANUAL,
                undefined,
                undefined,
                previousYearTemplate);

        }
        return null;
    }
}
